import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    filterList:'',
    boothList:'',
    count:0
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
